import { render } from "./CustomerOverView.vue?vue&type=template&id=36966b72&scoped=true"
import script from "./CustomerOverView.vue?vue&type=script&lang=js"
export * from "./CustomerOverView.vue?vue&type=script&lang=js"

import "./CustomerOverView.vue?vue&type=style&index=0&id=36966b72&scoped=true&lang=css"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36966b72"]])

export default __exports__